import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { UserContext, SnackbarContext } from "../../contexts";
import { useInput, usePagination } from "../../hooks";
import { FormInput, Button, Paging, Board } from "../../components";
import API from "../../api";
import Util from "../../util";
import { useTranslation } from "react-i18next";

export const BoardListPage = (props) => {
  const { t } = useTranslation(); // useTranslation 훅을 사용하여 t 함수를 가져옴

  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { updateToken, userInfo } = useContext(UserContext);
  const [list, setList] = useState(null);
  const [
    page,
    totalPage,
    totalCount,
    onPageChange,
    setPage,
    setTotalPage,
    setTotalCount,
  ] = usePagination(1, 10);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    requsetList();
  }, [page]);

  const requsetList = (init_page) => {
    setLoading(true);
    let params = {
      page: init_page ? init_page : page,
      limit: 10,
    };

    API.Board.GetFreeBoard(params).then(
      (res) => {
        let result = res.data;
        console.log("Board.GetNoticeresult", result);
        setList(result.items);
        setTotalPage(result.meta.totalPages);
        setTotalCount(result.meta.totalCount);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        updateSnackbar({
          type: "error",
          open: true,
          message: err.data.message,
        });
      }
    );
  };

  const onRowClick = (index) => {
    console.log("onRowClick", index);

    let target = list[index];
    history.push("/board/detail/" + target.no);
  };

  return (
    <article className="board-list-page">
      <div className="board__wrapper">
        <section className="title__box between">
          <h3>{t("free_board.list.title")}</h3>
          <div className="button__box">
            <Button
              label={t("free_board.list.button.write")}
              onClick={() => {
                if (userInfo) {
                  history.push("/board/add");
                } else {
                  updateSnackbar({
                    type: "error",
                    open: true,
                    message: t("system.alert.no_login"),
                  });
                  history.push("/login");
                }
              }}
            ></Button>
          </div>
        </section>

        <section className="board__box">
          <Board
            type={"free"}
            data={list}
            loading={loading}
            rowClick={onRowClick}
          ></Board>
        </section>

        <section className="page__box">
          <Paging
            page={page}
            totalPage={totalPage}
            onChange={onPageChange}
          ></Paging>
        </section>
      </div>
    </article>
  );
};
